import {InjectionToken} from '@angular/core';
import {Observable} from "rxjs";

export interface MxForgotPasswordService {
    forgotPassword(userName: string, email: string): Observable<void>;
}
export const MX_FORGOT_PASSWORD_SERVICE_TOKEN = new InjectionToken<MxForgotPasswordService>('MX_FORGOT_PASSWORD_SERVICE_TOKEN');
